import { DatePicker, type DatePickerProps, type FormItemProps } from "antd";
import type { ReactNode } from "react";
import { FormItem } from "~components/Form/FormItem";
import { FormSkeleton } from "~components/Form/FormSkeleton";
type Props<TForm> = FormItemProps<TForm> & {
  label?: ReactNode;
  showSkeleton?: boolean;
  /** `disabled` moved out of `datePickerProps` for convenience as it used frequently */
  disabled?: boolean;
  /** Antd `DatePickerProps` */
  datePickerProps?: Omit<DatePickerProps, "disabled">;
};

export const FormDatePicker = <TForm = unknown>({
  label,
  disabled,
  showSkeleton = false,
  datePickerProps,
  ...rest
}: Props<TForm>) => {
  const content = (
    <>
      {showSkeleton ? (
        <FormSkeleton label={label} />
      ) : (
        <FormItem<TForm> layout="vertical" className="form-date-item" label={label} {...rest}>
          <DatePicker disabled={disabled} {...datePickerProps} />
        </FormItem>
      )}
    </>
  );

  return rest.hidden ? content : <div>{content}</div>;
};
